export default __webpack_public_path__ + "bigganchinta-black.png";